import Swiper, { Autoplay } from 'swiper';

const initSwiper = () => {
  const swipers = document.querySelectorAll( '.hero-c-suite .swiper' );

  swipers.forEach( ( swiperElement ) => {
    const swiper = new Swiper( swiperElement, {
      modules: [ Autoplay ],
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 20,
      speed: 8000,
      autoplay: {
        delay: 0,
      },
      allowTouchMove: true,
      grabCursor: true,
      freeMode: {
        enabled: true,
        sticky: false,
      },
    } );

    const playButton = swiperElement.closest( '.stats' ).querySelector( '.play' );

    if ( playButton ) {
      playButton.addEventListener( 'click', () => {
        if ( swiper.autoplay.running ) {
          swiper.autoplay.stop();
          playButton.classList.add( 'active' );
        } else {
          swiper.autoplay.start();
          playButton.classList.remove( 'active' );
        }
      } );
    }
  } );
};

window.addEventListener( 'load', initSwiper );
